<template>
  <div id="customer-profile" class="customer-profile grid" v-if="survey">
    <div class="general border">
      <h3 class="profile-title bg-transparent capitalize" style="color: #000;">
        {{ customerInfo.full_name }}
      </h3>

      <div class="general__info1 flex justify-content-around">
        <div
          class="general__info1--age flex flex-column justify-content-between align-center"
        >
          <span>Age</span>
          <h2>{{ age || 'N/A' }}</h2>
        </div>
        <div
          class="general__info1--height flex flex-column justify-content-between align-center"
        >
          <span>height</span>
          <h2>{{ survey.height || 'N/A' }}</h2>
        </div>
        <div
          class="general__info1--hair flex flex-column justify-content-between align-center"
        >
          <span>Hair</span>
          <img
            v-if="survey.hair_color"
            :src="`/img/survey/hair/${survey.hair_color}.png`"
            alt="hair blonde"
          />
          <h2 v-else>{{ 'N/A' }}</h2>
        </div>
        <div
          class="general__info1--skin flex flex-column justify-content-between align-center"
        >
          <span>Skin</span>
          <img
            v-if="survey.skin_color"
            :src="`/img/survey/skin/${survey.skin_color}.png`"
            alt="skin 1"
          />
          <h2 v-else>{{ 'N/A' }}</h2>
        </div>
      </div>

      <div class="general__info2 flex small-margin-top">
        <div class="general__info2--photo clickable">
          <img
            :src="survey.image"
            alt=""
            v-if="survey.image"
            @click="$emit('showCustomerPhoto')"
          />
          <img src="/img/survey/upload-photo.png" alt="" v-else />
        </div>
        <div class="general__info2--reason flex flex-column text-center">
          <span>Reasons for using AnnoAnno</span>
          <div class="flex flex-wrap">
            <span class="card" v-for="(reason, index) in reasons" :key="index">
              {{ reason }}
            </span>
          </div>
        </div>
      </div>

      <div class="general__notes flex flex-column">
        <h4 class="small-margin-top very-small-margin-bottom">
          Customer Notes
        </h4>

        <button
          class="btn btn-xl full-width very-small-margin-bottom"
          @click="$emit('showFeedbackSummary')"
          :class="{ disabled: feedbackSummary === ''}"
        >
          FEEDBACK SUMMARY
        </button>
        <button
          class="btn btn-xl full-width very-small-margin-bottom"
          :class="{ disabled: !hasPrevOrders }"
          @click="$emit('showPrevModal')"
        >
          Previous Order
        </button>
        <button
          class="btn btn-xl full-width very-small-margin-bottom"
          :class="{ disabled: !hasStylistComments }"
          @click="$emit('showStylistComments')"
        >
          Stylist Comments
        </button>
        <button
          class="btn btn-xl full-width very-small-margin-bottom"
          :class="{ disabled: !hasCustomerComments }"
          @click="$emit('showCustomerComments')"
        >
          Customer Comments
        </button>
        <button
          class="btn btn-xl full-width"
          :class="{ disabled: !hasPreshippingFeedback }"
          @click="$emit('showPreshippingFeedback')"
        >
          Sneak Peek feedback
        </button>
      </div>
    </div>

    <div class="body-type border align-center">
      <h3 class="profile-title">
        Body Type
      </h3>
      <div class="body-type__image">
        <img :src="`/img/survey/body-type/${bodyType.image}.png`" alt="" />
        <span class="body-type__text capitalize">
          {{ bodyType.type }}
        </span>
      </div>
      <div class="body-type__confidence">
        <slider
          :value="bodyType.confidence"
          min-desc="Uncertain"
          max-desc="Certain"
          :sliderTrackHeight="6"
        />
      </div>
      <div class="flex flex-column small-margin-top full-width">
        <button
          class="btn bg-dark-grey full-width very-small-margin-bottom"
          @click="openBodyTypeModal"
        >
          More details
        </button>
      </div>
    </div>
    <div class="size border">
      <h3 class="profile-title">
        Size
      </h3>
      <div class="size__category flex justify-content-around">
        <div
          class="size__category--item"
          v-for="(value, key) in sizes"
          :key="key"
        >
          <span class="uppercase">{{ key }}</span>
          <img :src="`/img/survey/sizes/${key}.png`" alt="" />
          <span class="size__category--value" v-html="value"></span>
        </div>
      </div>

      <h3 class="profile-title bg-transparent text-black no-margin-bottom">
        Fit
      </h3>
      <hr
        style="border-bottom: 3px solid #000;"
        class="no-margin small-margin-right small-margin-left"
      />

      <div class="size__fit flex justify-content-around" v-if="fit">
        <div class="size__fit--item">
          <span class="uppercase">Upper</span>
          <img src="/img/survey/fit/upper.png" alt="" />
          <span class="size__fit--value">{{ fit.upper }}</span>
        </div>
        <div class="size__fit--item">
          <span class="uppercase">Lower</span>
          <img src="/img/survey/fit/lower.png" alt="" />
          <span class="size__fit--value">{{ fit.lower }}</span>
        </div>
        <div class="size__fit--item">
          <span class="uppercase">Dress</span>
          <img src="/img/survey/fit/dress.png" alt="" />
          <span class="size__fit--value">{{ fit.dress }}</span>

          <template v-if="fit.dislike">
            <span class="size__fit--extra" v-html="fit.dislike"></span>
          </template>
        </div>
      </div>
    </div>

    <!-- A CardSurvey customer has neither the old style answers nor budget questions: her profile takes their place. -->
    <div v-if="cardSurveySections.length" class="card-survey-profile border">
      <h3 class="profile-title">Survey 2.0 (CardSurvey): what the AI reads</h3>
      <div class="card-survey-profile__sections">
        <div v-for="section in cardSurveySections" :key="section.title" class="card-survey-profile__section">
          <h4 class="very-small-margin-bottom">{{ section.title }}</h4>
          <ul class="card-survey-profile__lines">
            <li v-for="line in section.lines" :key="line">{{ line }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="!cardSurveySections.length" class="style border">
      <h3 class="profile-title">
        Style
      </h3>
      <div
        class="style__type flex justify-content-around very-small-margin-top"
        v-if="styleTypes"
      >
        <div
          v-for="(type, index) in styleTypes"
          :key="index"
          class="style__type--item"
          :class="type.className"
        >
          <span class="capitalize">{{ type.key }}</span>
          <h3 class="no-margin">{{ type.value }}</h3>
        </div>
      </div>
      <div class="style__category small-margin-top">
        <div class="full-width">
          <div class="style__category--item margin-auto">
            Style: <br />
            <strong class="capitalize">{{ styleCategories.style }}</strong>
          </div>
        </div>
        <div class="flex justify-content-around very-small-margin-top">
          <div class="style__category--item very-small-margin-right">
            Work: <br />
            <strong class="capitalize">{{ styleCategories.work }}</strong>
          </div>
          <div class="style__category--item very-small-margin-left">
            Colorfullness: <br />
            <strong class="capitalize">{{
              styleCategories.colorfulness
            }}</strong>
          </div>
        </div>
        <div class="flex justify-content-around very-small-margin-top">
          <div class="style__category--item very-small-margin-right">
            Leisure: <br />
            <strong class="capitalize">{{ styleCategories.leisure }}</strong>
          </div>
          <div class="style__category--item very-small-margin-left">
            Challenge: <br />
            <strong class="capitalize">{{ styleCategories.challenge }}</strong>
          </div>
        </div>
      </div>

      <h3
        class="profile-title bg-transparent text-black no-margin-bottom small-margin-top"
      >
        Don't like
      </h3>
      <div class="style__notlike flex justify-content-around flex-wrap">
        <div
          class="style__notlike--item"
          v-for="(item, index) in dislike"
          :key="index"
        >
          <img :src="`/img/survey/styles/${item}.png`" alt="" />
          <span class="style__notlike--name capitalize">{{ item }}</span>
        </div>
        <strong v-if="!dislike || dislike.length === 0" class="capitalize">{{ 'N/A' }}</strong>
      </div>
    </div>

    <div v-if="!cardSurveySections.length" class="budget border padding-top">
      <h3 class="profile-title">
        Budget
      </h3>

      <div class="small-margin-right small-margin-left">
        <slider
          :value="quality_vs_price"
          min-desc="Low price"
          max-desc="High quality"
        />
      </div>

      <div class="budget__price flex justify-content-around">
        <div
          class="budget__price--item"
          v-for="(value, key) in prices"
          :key="key"
        >
          <span class="uppercase very-small-margin-bottom capitalize">{{
            key
          }}</span>
          <img :src="`/img/survey/sizes/${key}.png`" alt="" />
          <span class="budget__price--value">{{ value || 'N/A'}} </span>
        </div>
      </div>

      <div class="interaction flex justify-content-around">
        <div class="interaction__contact flex flex-column align-center">
          <h3 class="profile-title bg-transparent text-black no-margin-bottom">
            Contact info
          </h3>
          <hr
            style="border-bottom: 3px solid #000;"
            class="no-margin full-width"
          />

          <div style="align-self: flex-start;" class="small-margin-top">
            <strong>Phone: </strong>
            <span>{{ customerInfo.phone }}</span>
          </div>
          <div style="align-self: flex-start;" class="small-margin-top">
            <strong>Email: </strong>
            <span>{{ customerInfo.email }}</span>
          </div>
          <div style="align-self: flex-start;" class="small-margin-top">
            <strong>ID: </strong>
            <span>{{ customerInfo.id }}</span>
          </div>
        </div>

        <div class="interaction__action flex flex-column align-center">
          <h3 class="profile-title bg-transparent text-black no-margin-bottom">
            Customer Interaction
          </h3>
          <hr
            style="border-bottom: 3px solid #000;"
            class="no-margin full-width"
          />

          <div
            data-testid="interaction-actions"
            class="interaction__action--items flex justify-content-around small-margin-top"
          >
            <button
              data-testid="new-send-email-btn"
              class="interaction--item bg-pink"
              @click="sendEmail"
              ref="button-email"
            >
              <small>Send</small>
              <span>Email</span>
            </button>
            <button
              data-testid="new-send-sms-btn"
              class="interaction--item bg-dark-grey"
              @click="sendSMS"
              ref="button-sms"
            >
              <small>Send</small>
              <span>SMS</span>
            </button>
            <button data-testid="new-preshipping-btn" class="interaction--item uppercase bg-dark"
              @click="$emit('sendPreshipping')"
              ref="button-preshipping">
              <span>SNEAK</span>
              <span>PEEK</span>
            </button>
            <button
              data-testid="new-missedcall-btn"
              class="interaction--item uppercase bg-dark"
              @click="sendPreshippingMissedMessage"
              ref="button-preshipping-missed"
            >
              <span>SP</span>
              <small>MISSED CALL</small>
            </button>
          </div>
          <div class="interaction__action--items flex justify-content-around small-margin-top">
            <button data-testid="check-stock-btn"
              class="interaction--item bg-pink"
              @click="$emit('checkStock')">
              <small>Check</small>
              <span>Stock</span>
            </button>
            <button data-testid="new-recommender-btn"
              class="square--item"
              @click="$emit('recommender')">
              <span>Recom</span>
              <span>mender</span>
            </button>
            <button data-testid="new-recommender-btn"
              class="square--item bg-transparent">
            </button>
            <button data-testid="new-recommender-btn"
              class="square--item bg-transparent">
            </button>
          </div>
        </div>
      </div>
    </div>
    <modal
      name="bodyTypeModal"
      v-if="bodyTypeModalShow"
      @close="bodyTypeModalShow = false"
    >
      <div
        v-click-outside="
          () => {
            bodyTypeModalShow = false;
          }
        "
      >
        <BodyTypeModal :bodyType="bodyType" />
      </div>
    </modal>

    <div class="notify-wrapper flex align-center" v-if="notifyShow">
      <SvgFile name="error" v-if="notify.status === 'error'" color="#FE0006" />
      <SvgFile name="ok" v-if="notify.status === 'success'" color="#4DAA00" />
      <h2 class="no-margin very-small-margin-left" :class="notify.status">
        {{ notify.message }}
      </h2>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import Slider from '../Slider.vue'
import { bodyTypesMatrix } from './bodyTypes'
import BodyTypeModal from './BodyTypeModal.vue'
import AdditionalPSPreCheck from './AdditionalPSPreCheck.vue'

let loader

export default {
  name: 'CustomerProfile',

  props: {
    survey: {
      type: Object,
      default: null
    },
    customerInfo: {
      type: Object,
      required: true
    },
    hasPreshippingFeedback: {
      type: Boolean,
      default: false
    },
    hasPrevOrders: {
      type: Boolean,
      default: false
    },
    feedbackSummary: {
      type: String,
      default: ""
    },
    styling: {
        type: Object,
        default: null
    }
  },

  components: {
    Slider,
    BodyTypeModal
  },

  data: () => ({
    bodyTypeModalShow: false,
    // hasPrevOrders: false,
    clickedButton: null,
    notifyShow: false,
    notify: {
      status: 'success',
      message: 'Hello World'
    },
    dashboardBaseUrl: process.env.VUE_APP_WEBSITE_URL,
    additionalPSRequested: false
  }),

  computed: {
    // A CardSurvey (Survey 2.0) customer's answers as the AI stylists read them: "**Header:**" sections of "- " lines.
    cardSurveySections () {
      const text = this.survey.card_survey_profile
      if (!text) return []
      return text.split('\n\n**').filter(chunk => chunk).map(chunk => {
        const [header, ...lines] = chunk.split('\n')
        return { title: header.replace(/:\*\*$/, ''), lines: lines.map(line => line.replace(/^- /, '')) }
      })
    },
    age () {
      const { birthday } = this.survey
      return moment().diff(birthday, 'years')
    },
    styleTypes () {
      const temp = []
      for (const [key, value] of Object.entries(this.survey.style)) {
        temp.push({
          key: /style_(.*)/.exec(key)[1],
          value: value ? Math.ceil((value < 1 ? 1 : value) / 20) : 'N/A',
          className: `class-${this.colorFun(value)}`
        })
      }
      return temp
    },
    countryID () {
      const {
        locale: { country_id: countryID }
      } = this.customerInfo
      return countryID
    },
    styleCategories () {
      const {
        characteristic: style,
        outfit_at_work: work,
        outfit_off_work: leisure,
        outfit_colorful: colorfulness,
        outfit_challenged: challenge,
        wear_uniform: uniform
      } = this.survey.need

      const StyleFun = (input, value1, value2) => {
        switch (Math.ceil(Number(input) / 20)) {
          case 0:
          case 1:
            return `Very ${value1}`
          case 2:
            return value1
          case 3:
            return 'Middle'
          case 4:
            return value2
          case 5:
            return `Very ${value2}`
          default:
            return 'none'
        }
      }

      return {
        style: style ? StyleFun(style, 'simple', 'patterned') : 'N/A',
        work: work ? Number(uniform) ? 'Uniform' : StyleFun(work, 'Chill', 'Formal') : 'N/A',
        leisure: leisure ? StyleFun(leisure, 'Chill', 'Formal') : 'N/A',
        colorfulness: colorfulness ? StyleFun(colorfulness, 'Little', 'Much') : 'N/A',
        challenge: challenge ? StyleFun(challenge, 'Little', 'Much') : 'N/A'
      }
    },
    fit () {
      if (!this.survey) return null
      let {
        fit_upper_parts: upper,
        fit_under_parts: lower,
        dress_length: dress,
        dislike_dress,
        dislike_skirts
      } = this.survey.fit
      dislike_dress = Number(dislike_dress)
      dislike_skirts = Number(dislike_skirts)

      let dislike = ''
      if (dislike_dress) dislike += 'No <strong>dresses</strong><br />'
      if (dislike_skirts) dislike += 'No <strong>skirts</strong>'
      return {
        upper: upper ? this.fitValue(upper) : 'N/A',
        lower: lower ? this.fitValue(lower) : 'N/A',
        dress: dress || 'N/A',
        dislike
      }
    },
    dislike () {
      const parsed = JSON.parse(this.survey.fit.fit_do_not_like[0] || null)
      // Drop empty/falsy entries so we never render `/img/survey/styles/.png` (404).
      return Array.isArray(parsed) ? parsed.filter(Boolean) : parsed
    },
    sizes () {
      const {
        upper: tops,
        lower: pants,
        dress: dresses,
        cup_size: cup,
        bra: bandLength
      } = this.survey.sizes
      return {
        tops: tops || 'N/A',
        pants: pants || 'N/A',
        dresses: dresses || 'N/A',
        bra: bandLength ? `${bandLength}<br />${cup}` : 'N/A'
      }
    },
    quality_vs_price () {
      const { quality_vs_price: value } = this.survey.price
      return Number(value)
    },
    prices () {
      const priceRanges = [
        ['200-500', '500-700', '700-900', '+900'],
        ['250-700', '700-1000', '1000-1300', '+1300'],
        ['25-70', '70-90', '90-120', '+120'],
        ['25-70', '70-90', '90-120', '+120']
      ]
      const priceRange = priceRanges[this.countryID - 1]
      let {
        price_top: upper,
        price_jackets: jackets,
        price_trousers: pants,
        price_dresses: dresses
      } = this.survey.price
      upper = upper ? this.$options.filters
        .toCurrency(priceRange[upper])
        .replace(' ', '\n') : 'N/A'
      jackets = jackets ? this.$options.filters
        .toCurrency(priceRange[jackets])
        .replace(' ', '\n') : 'N/A'
      pants = pants ? this.$options.filters
        .toCurrency(priceRange[pants])
        .replace(' ', '\n') : 'N/A'
      dresses = dresses ? this.$options.filters
        .toCurrency(priceRange[dresses])
        .replace(' ', '\n') : 'N/A'
      return {
        upper,
        jackets,
        pants,
        dresses
      }
    },
    reasons () {
      const { why_annoanno: reasons } = this.survey
      return JSON.parse(reasons)
    },
    bodyType () {
      const {
        body_type: {
          breast_vs_hips,
          breast_vs_waist,
          waist_vs_hips,
          confident_answers_level
        }
      } = this.survey
      let type
      if (breast_vs_hips * breast_vs_waist * waist_vs_hips != 0) {
        type =
          bodyTypesMatrix[breast_vs_hips - 1][waist_vs_hips - 1][
            breast_vs_waist - 1
          ]
      } else type = 'N/A'
      const confidence = confident_answers_level
        ? Number(confident_answers_level)
        : 0

      return {
        type,
        breast_vs_hips,
        breast_vs_waist,
        waist_vs_hips,
        confidence,
        image: type.replace(' ', '-')
      }
    },

    hasStylistComments () {
      return this.customerInfo.stylistComments
        ? this.customerInfo.stylistComments.length > 0
        : false
    },
    hasCustomerComments () {
      return this.customerInfo.customerComments
        ? this.customerInfo.customerComments.length > 0
        : false
    }
  },

  methods: {
    colorFun (value) {
      switch (Math.ceil(Number(value) / 20)) {
        case 0:
        case 1:
        case 2:
          return 'pink'
        case 3:
          return 'yellow'
        case 4:
        case 5:
          return 'green'
        default:
          return 'none'
      }
    },
    fitValue (value) {
      switch (Math.ceil(Number(value / 20))) {
        case 0:
        case 1:
          return 'Very loose'
        case 2:
          return 'Loose'
        case 3:
          return 'Middle'
        case 4:
          return 'Tight'
        case 5:
          return 'Very tight'
        default:
          break
      }
    },
    openBodyTypeModal () {
      this.$emit('openBodyTypeModal', this.bodyType)
    },
    sendEmail () {
      Vue.api.get(
        `order/${this.$route.query.id}/email-with-styles`,
        {},
        {
          before: () => (this.clickedButton = 'email'),
          always: () => (this.clickedButton = ''),
          callback: () => {
            this.showNotify({
              status: 'success',
              message: 'Email sent with styles'
            })
            setTimeout(() => {
              window.open(
                `${this.dashboardBaseUrl}/styling-ordre/?orderID=${this.$route.query.id}&key=${this.$route.query.key}`,
                '_blank'
              )
            }, 500)
          },
          error: (error) => {
            this.showNotify({ status: 'error', message: error.data.message })
          }
        }
      )
    },
    sendSMS () {
      Vue.api.get(
        `order/${this.$route.query.id}/sms-with-styles`,
        {},
        {
          before: () => (this.clickedButton = 'sms'),
          always: () => (this.clickedButton = ''),
          callback: () => {
            this.showNotify({
              status: 'success',
              message: 'SMS sent with styles'
            })
            setTimeout(() => {
              window.open(
                `${this.dashboardBaseUrl}/styling-ordre/?orderID=${this.$route.query.id}&key=${this.$route.query.key}`,
                '_blank'
              )
            }, 500)
          },
          error: (error) => {
            this.showNotify({ status: 'error', message: error.data.message })
          }
        }
      )
    },

    sendPreshippingMissedMessage () {
      if (confirm('This button shall only be used, if customer did not pick up the phone. Is this the case?')) {
        Vue.api.post(
          `order/${this.$route.query.id}/send-preshipping-missed`,
          {},
          {
            before: () => {
              this.clickedButton = 'preshipping-missed'
              loader = this.$loading.show()
            },
            always: () => {
              this.clickedButton = ''
              loader.hide()
            },
            callback: () => {
              this.showNotify({
                status: 'success',
                message: 'Sneak Peek text message sent'
              })
            },
            error: (error) => {
              this.showNotify({ status: 'error', message: error.data.message })
            }
          }
        )
      }
    },

    showNotify (notify) {
      this.notify = notify
      this.notifyShow = true
      setTimeout(() => {
        this.notify = { status: '', message: '' }
        this.notifyShow = false
      }, 3000)
    }
  },

  watch: {
    clickedButton (newVal, oldVal) {
      if (newVal) {
        this.$refs['button-' + newVal].disabled = true
      } else {
        this.$refs['button-' + oldVal].disabled = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../styles/variables.less";
@responsive-breakpoint: 1600px;

.customer-profile {
  grid-template-columns: 15% 10% 24% 25% auto;
  grid-column-gap: 5px;

  & > div {
    display: flex;
    flex-direction: column;
    padding: 5px;
  }

  .card-survey-profile {
    // Style + Budget's two columns. (Never `grid-column: a / b` here: LESS divides it.)
    grid-column-end: span 2;

    &__sections {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    &__lines {
      margin: 0;
      padding-left: 16px;
    }
  }

  .general {
    &__info1 {
      h2 {
        margin-bottom: 10px;
        margin-top: 10px;
      }
      img {
        max-width: 36px;
      }
    }

    &__info2 {
      @media screen and (max-width: @responsive-breakpoint) {
        flex-direction: column;
        align-items: center;
        margin-top: 5px;
      }

      &--photo {
        &:hover {
          opacity: 0.8;
        }
        img {
          width: 60px;
        }
      }
      &--reason {
        .card {
          padding: 2px 8px;
          background-color: #ddeef7;
          font-size: 12px;
          margin: 2px;
          display: flex;
          align-items: center;
        }
      }
    }

    &__notes {
      .btn {
        background-color: @pink !important;

        &.disabled {
          background-color: @grey !important;
        }
      }
    }
  }

  .body-type {
    &__image {
      position: relative;
      width: 100%;
      height: 230px;
      text-align: center;
      padding: 10px 0;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    &__text {
      position: absolute;
      text-align: center;
      font-size: 24px;
      font-weight: 700;
      top: 20%;
      left: 50%;
      transform: translateX(-50%);
      // line-height: 34px;
    }
  }

  .size {
    &__category,
    &__fit {
      position: relative;

      &--item {
        display: flex;
        flex-direction: column;
        position: relative;
        padding: 5px;
        align-items: center;

        @media screen and (max-width: @responsive-breakpoint) {
          padding: 3px;
        }

        img {
          max-height: 100px;
          max-width: 100%;

          @media screen and (max-width: @responsive-breakpoint) {
            max-height: 80px;
          }
        }
      }

      &--value {
        position: absolute;
        text-align: center;
        top: 50px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 20px;
        font-weight: 700;
        line-height: 18px;
      }
    }

    &__fit {
      &--value {
        font-size: 18px;
        font-weight: 500;
        line-height: 20px;
      }

      &--extra {
        display: block;
        padding: 10px 0;
        position: relative;

        &::after {
          content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAPlQTFRFAAAA86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ag86ago8PO4gAAAFN0Uk5TABVxstjx/e/VrmgPM7T5//arJg2k/PqWCeLWI0Xy0WsSAgM5dd3rL0ABTN8iXQyh0/tVAIyCqeGSYA5LmE7FHOoFH+hUwJ6FbgpmhPgZcsEGFyAeld1jAAABdElEQVR4nG2T53bCMAyFRdmrAUqAshNm2SPsFQh70/d/mMpOGcHWj2td6bPl+JwAPML0YbZYbTa7w+lyAxse76fwCJ8/8Nb+CoqCIULhiGH7t8BENPbsxxO0lEx50pJsymRz1OYLj/20nyz+3AtSqUyJyv98/fzq68xanZQa+j2C+sxm65VoK6TWoQPu938juuRbyBAvmV9tMkSth6U+vh95nyK0WGJAXmwIH+QAvD9LSOSIEZhRU8SzxBgLClhQPcAlJuinYEVNA5eYoVXBhioBl5DRiRSQgUvMKWBHNQGXWGCugQM1A1xiiekKnKhZ4BJrzDbgQs1JPELWMImD24dLCTjEFpfEDsCPa7nGEnsV9YA2EMKk3mYIEscTsWGSKlziTF0kSvKuYcqe9i9X3cXyxPUGj2+Rtyqt3O6FAiWE3ngyk+eL5VrT7e/zxEqD/XEuN3iJSCdkbB/PVzBGpe97thOHE7AxHClTVRS11Sa+e1b/AGC9PYncAaWfAAAAAElFTkSuQmCC");
          position: absolute;
          height: 32px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: -1;
        }
      }
    }
  }

  .style {
    &__type {
      &--item {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 18px;
        padding: 5px;
        flex-grow: 1;
        flex-basis: 100px;
        overflow: hidden;

        &:not(:last-of-type) {
          margin-right: 5px;
        }

        &.class-pink {
          background-color: #fae0de;
        }
        &.class-green {
          background-color: #d9f3e4;
        }
        &.class-yellow {
          background-color: #ffebb4;
        }
      }
    }

    &__category {
      &--item {
        width: 45%;
        padding: 5px 10px;
        background-color: #ddeef7;
        text-align: center;
      }
    }

    &__notlike {
      &--item {
        position: relative;
        margin: 2px;
        padding: 2px;
        border: 2px solid #ed7f76;
        display: flex;
        justify-content: center;
        align-items: center;

        &::before {
          content: "";
          background: url(data:image/png;base64,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);
          background-size: 100% 100%;
          z-index: 100;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }

        img {
          max-width: 40px;
          max-height: 60px;
        }
      }

      &--name {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .budget {
    &__price {
      position: relative;

      &--item {
        display: flex;
        flex-direction: column;
        position: relative;
        padding: 5px;
        align-items: center;
        img {
          max-height: 70px;
          max-width: 100%;

          @media screen and (max-width: @responsive-breakpoint) {
            max-height: 56px;
          }
        }
      }

      &--value {
        position: absolute;
        text-align: center;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -30%);
        font-size: 15px;
        font-weight: 700;
        line-height: 16px;
        white-space: pre;
      }
    }

    .interaction {
      @media screen and (max-width: @responsive-breakpoint) {
        flex-direction: column;
        padding: 0 10px;

        &__action {
          &--items {
            width: 100%;
          }
        }
      }
    }

    .interaction--item {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
    }

    .stock-view {
      width: 100%;
      justify-content: left;
      margin-top: 10px;

      @media screen and (max-width: @responsive-breakpoint) {
        padding-left: 5px;
      }
    }
    .square--item {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0;
      color: #FFF;
      background-color: #B40439;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
    }
  }

  .profile-title {
    color: #fff;
    text-align: center;
    background-color: #051623;
    padding: 7px;
    margin: 0;
    margin-bottom: 10px;
    width: 100%;
    align-self: center;

    @media screen and (max-width: @responsive-breakpoint) {
      margin-bottom: 2px;
    }
  }

  @media screen and (max-width: @responsive-breakpoint) {
    zoom: 0.85;
  }
}

.notify-wrapper {
  position: absolute;
  right: 0;
  top: 20px;
  background: rgba(255, 255, 255, 0.6);
  padding: 10px;
  border-radius: 5px;
}
</style>
